import { StatusDot } from '@zyxantech/tux'
import { useEffect, useState } from 'react'
import { useTenant } from '@/hooks/useTenant'
import { useRealtimeStore } from '@/store/realtime.store'

const WS_STATUS_LABEL: Record<string, string> = {
  connected: 'Live',
  connecting: 'Connecting…',
  disconnected: 'Offline',
  error: 'Connection error',
}

/**
 * Thin status strip below the top bar: tenant, a live clock, and the realtime
 * connection state. The clock ticks every second; the WS state is wired in
 * Stage 7 (shows "Offline" until then).
 */
export function StatusBar() {
  const { tenantName, tenantId } = useTenant()
  const wsStatus = useRealtimeStore((s) => s.wsStatus)
  const [now, setNow] = useState(() => new Date())

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000)
    return () => clearInterval(id)
  }, [])

  const isLive = wsStatus === 'connected'

  return (
    <div className="flex items-center justify-between border-b border-border-subtle bg-bg-surface px-4 py-1.5 text-xs text-text-muted">
      <div className="flex items-center gap-2">
        <span className="text-text-secondary">
          {tenantName.length > 0 ? tenantName : (tenantId ?? '—')}
        </span>
      </div>
      <div className="flex items-center gap-4">
        <span className="font-mono tabular-nums text-text-secondary">
          {now.toLocaleString('en-US', {
            month: 'short',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false,
          })}
        </span>
        <span className="flex items-center gap-1.5">
          <StatusDot status={isLive ? 'online' : 'offline'} pulse={isLive} size="sm" />
          {WS_STATUS_LABEL[wsStatus] ?? 'Offline'}
        </span>
      </div>
    </div>
  )
}
